import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';

@Component({
  selector: 'app-datatypes',
  templateUrl: './datatypes.component.html',
  styleUrls: ['./datatypes.component.scss'],
  imports: [CommonModule, CeIconComponent],
})
export class DatatypesComponent implements OnInit {
  constructor(private sanitizer: DomSanitizer) {}
  ngOnInit(): void {}

  @Input()
  label = 'array';

  @Input()
  size: 'medium' | 'large' = 'medium';

  @Input()
  Type: any;
}
